export const SITE_URL =
  import.meta.env.VITE_SITE_URL ??
  (typeof window !== "undefined" ? window.location.origin : "https://ovvocamping.it");

export const DEFAULT_META = {
  title: "Gestionale per campeggi: software completo | Ovvo Camping",
  description: "Software gestione campeggio e villaggi turistici. Prenotazioni online, check-in digitale, invio automatico Alloggiati Web, mappa interattiva. Provalo ora.",
  image: `${SITE_URL}/og-image.jpg`,
  type: "website"
};
